import type { RxJsonSchema } from 'rxdb';
import type { OrderDocType } from '../types/order';

export const orderSchema: RxJsonSchema<OrderDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    orderNumber: { type: 'string', maxLength: 30 },
    items: { type: 'array', items: { type: 'object' }, default: [] },
    subtotal: { type: 'number', default: 0 },
    discount: { type: 'number', default: 0 },
    discountType: { type: 'string', enum: ['percent', 'amount'], default: 'amount' },
    tax: { type: 'number', default: 0 },
    total: { type: 'number', default: 0 },
    paymentMethod: { type: 'string', enum: ['cash', 'card', 'qris', 'mixed'], default: 'cash' },
    paidAmount: { type: 'number', default: 0 },
    changeAmount: { type: 'number', default: 0 },
    status: { type: 'string', enum: ['draft', 'pending', 'completed', 'cancelled', 'refunded'], default: 'draft' },
    customerId: { type: 'string', maxLength: 36 },
    tableNumber: { type: 'string', maxLength: 20 },
    orderType: { type: 'string', enum: ['dine-in', 'takeaway', 'delivery'], default: 'takeaway' },
    kitchenNotes: { type: 'string', maxLength: 500 },
    receiptPrinted: { type: 'boolean', default: false },
    syncedAt: { type: 'string' },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'orderNumber', 'createdAt', 'updatedAt'],
  indexes: ['status', 'customerId', 'createdAt', 'orderNumber'],
};
